
export const generateOrderNumber = (prefix: 'RO' | 'RSO'): string => {
  const timestamp = Date.now().toString().slice(-6);
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `${prefix}${timestamp}${random}`;
};

export const generateRewardOrderNumber = (): string => {
  return generateOrderNumber('RO');
};

export const generateRewardSalesOrderNumber = (): string => {
  return generateOrderNumber('RSO');
};
